import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-overlay/dist/index.module.css';
function Overlay(props) {
  const {
    isOpen = false,
    className = '',
    children = null
  } = props;
  const overlayClasses = classNames({
    [styles['sib-header-overlay']]: true,
    [styles['sib-header-overlay-toggled']]: isOpen,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", {
    className: overlayClasses
  }, children);
}
Overlay.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
};
export default Overlay;